import { Component, Input } from '@angular/core';
import { Loadable } from '../helpers/loadable';
import { errorMessage } from '../load/load';

@Component({
  selector: 'submit-error',
  styleUrls: ['./submit-error.component.scss'],
  templateUrl: './submit-error.component.html',
})
export class SubmitErrorComponent {
  @Input()
  load?: Loadable<unknown>;

  get errorMessage() {
    return errorMessage(
      "We're having issues. Try again later.",
      this.load!.error,
    );
  }
}
